export class GruppeStandortWechselnDialogResult {
    confirm: boolean = false;
}
